module.exports = __webpack_public_path__ + "static/media/car.05604de9.svg";